import { animalDropdownNoOption } from "../graphql/useAnimalTypesOptions";
import { Information } from "../texts";
import type { Animal } from "./optionTransformers";

export const resolveAnimalsInformationText = (
  livestock: boolean | null,
): string | undefined =>
  livestock ? Information.AnimalsInformation : undefined;

export const includeYesOption = (
  livestockType?: Animal | null,
  livestock?: boolean,
): boolean => {
  if (livestock) {
    return !livestockType
      ? true
      : livestockType.value === animalDropdownNoOption.value;
  } else {
    return false;
  }
};

export const isAnimalLivestockType = (livestockType: Animal): boolean =>
  livestockType.value !== animalDropdownNoOption.value;
